import {
  Card,
  CardContent,
  Chip,
  Container,
  Grid,
  makeStyles,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { PlayCircleFilled, Update } from '@material-ui/icons';
import React from 'react';
import { useDispatch } from 'react-redux';
import Flag from '../../components/Flag';
import { setMessage } from '../../redux/message';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: 0,
  },
  card: {
    minWidth: 100,
    height: 100,
  },
  header: {
    display: 'flex',
    padding: 0,
    justifyContent: 'space-between',
  },
  item: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  incidentName: {
    fontSize2: 16,
    marginBottom: 12,
  },
}));

const PlayItem = ({ item, onResume }) => {
  const dispatch = useDispatch();
  const copyToClipboard = (content) => {
    const el = document.createElement('textarea');
    el.value = content;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    dispatch(setMessage('Task link copied to clipboard', 'success'));
  };

  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardContent
        style={{
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }}
      >
        {item.incidentId ? (
          <Container className={classes.header}>
            <Grid container>
              <Grid item xs={9}>
                <div style={{ display: 'flex' }}>
                  <Flag item={item} />
                  <Typography className={classes.item} color="textSecondary">
                    {item.companyName}
                  </Typography>
                </div>
                <Typography className={classes.item} color="textSecondary">
                  {item.incidentName}
                </Typography>
                <Typography className={classes.item}>{item.taskName}</Typography>
              </Grid>
              <Grid item xs={3} style={{ textAlign: 'right' }}>
                {item.incidentId && (
                  <Tooltip title="Click to get a task link that can be used in recurring meetings">
                    <Chip
                      onClick={(e) => {
                        e.stopPropagation();
                        copyToClipboard('taskid:' + item.taskId);
                      }}
                      label={item.incidentId}
                      variant="outlined"
                    />
                  </Tooltip>
                )}
                <div style={{ display: 'flex' }}>
                  <Tooltip title="Start recording time for this task">
                    <PlayCircleFilled
                      className="hoverShow"
                      fontSize="large"
                      style={{ marginTop: 8, color: 'green' }}
                    />
                  </Tooltip>
                  {/* <Tooltip title="Resume this task with the same description">
                    <Update
                      className="hoverShow"
                      fontSize="large"
                      style={{ marginTop: 8, color: '#0d47a1' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (onResume) onResume();
                      }}
                    />
                  </Tooltip> */}
                </div>
              </Grid>
            </Grid>
          </Container>
        ) : (
          <Container className={classes.header}>
            <Grid container>
              <Grid item xs={9}>
                <Typography className={classes.item}>New</Typography>
                <Typography className={classes.item} color="textSecondary">
                  Click here if the desired
                </Typography>
                <Typography className={classes.item} color="textSecondary">
                  task is not listed below
                </Typography>
              </Grid>
              <Grid item xs={3} style={{ textAlign: 'center' }}>
                <br />
                <PlayCircleFilled
                  className="hoverShow"
                  fontSize="large"
                  style={{ marginTop: 8, color: 'green' }}
                />
              </Grid>
            </Grid>
          </Container>
        )}
      </CardContent>
    </Card>
  );
};

export default PlayItem;
